import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    maxHeight: { type: Number, default: 160 },
    scrollNoticeSelector: String
  }

  connect() {
    this.resizeObserver = new ResizeObserver(() => this.resize())

    this.resizeObserver.observe(this.element)

    if (this.hasInputTarget) {
      this.resizeObserver.observe(this.inputTarget)
    }

    this.resize()
  }

  disconnect() {
    this.resizeObserver?.disconnect()
  }

  resize() {
    if (!this.hasInputTarget) {
      return
    }

    this.inputTarget.style.height = "auto"

    const nextHeight = Math.min(this.inputTarget.scrollHeight, this.maxHeightValue)
    this.inputTarget.style.height = `${nextHeight}px`
    this.inputTarget.style.overflowY = this.inputTarget.scrollHeight > this.maxHeightValue ? "auto" : "hidden"
  }

  scrollToNotice() {
    if (!this.hasScrollNoticeSelectorValue) {
      return
    }

    const notice = document.querySelector(this.scrollNoticeSelectorValue)
    if (!notice) {
      return
    }

    requestAnimationFrame(() => {
      notice.scrollIntoView({ behavior: "smooth", block: "center" })
    })
  }
}
